import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TextTruncate from 'react-text-truncate';
import { parseYouTubeUrl, convertYouTubeIdToImg } from 'appSrc/utils/video';
import TheaterPlayIcon from 'appSrc/components/Shards/Theater/PlayIcon';
import style from './styles/style.module.css';
import { connect } from 'react-redux';
import { showModal } from 'appSrc/redux/actions';

class ReviewRowCard extends PureComponent {

    playMovie = (youTubeId, metaData) => {
        this.props.playMovie(youTubeId, metaData);
    }

    render() {
        const { review } = this.props;

        var video = review.video_url;
        var videoId, videoImage;
        if( video ) {
            videoId = parseYouTubeUrl( video );
            videoImage = convertYouTubeIdToImg( videoId, 'med/jpg' );
        }

        const movieMetaData = {
            attached_to: 'review_video',
            attached_id: review.id,
            video_author_id: review.userid,
        };

        return (
            <div onClick={ () => this.playMovie( videoId, movieMetaData ) } className={ `${ style.reviewRowCard } ${ this.props.className }`.trim() }>
                { video &&
                    <div className={ style.video }>
                        <img className={ style.videoImage } src={ videoImage } />
                        <TheaterPlayIcon className={ style.playIcon } youtubeId={ videoId }
                        metaData={ movieMetaData } />
                    </div>
                }
                <div className={ style.text }>
                    <div className={ style.type }>Review</div>
                    <TextTruncate
                    line={ 2 }
                    text={ review.title }
                    title={ review.title }
                    containerClassName={ style.title }/>
                </div>

            </div>
        );
    }
}
ReviewRowCard.propTypes = {
    review: PropTypes.object.isRequired,
};
ReviewRowCard.defaultProps = {
    className: '',
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        playMovie: ( youtubeId, metaData ) => {
            dispatch( showModal( 'movieTheater', { youtubeId: youtubeId, metaData: metaData } ) );
        },
    };
};

export default connect( null, mapDispatchToProps )( ReviewRowCard );
